// extracted by mini-css-extract-plugin
export default {"platforms":"DownloadCTASection_platforms__XHV+L","platformBtn":"DownloadCTASection_platformBtn__JgfG4"};